import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonGroup, Button } from "react-bootstrap";
import { setChartViewType } from "../../../actions/dashboard";

const SubViewToggle = (props) => {
  const dispatch = useDispatch();
  const { visibleSubView } = props;
  const chartViewType = useSelector((state) => state.dashboard.loads.chartViewType);
  const loadHistory = useSelector((state) => state.dashboard.loads.loadHistory);
  const isDisable = loadHistory && loadHistory.payload.length === 0;

  if (!visibleSubView) return null;

  return (
    <ButtonGroup toggle={true} className="btn-grp">
      {[
        { id: 1, name: "Load count" },
        { id: 2, name: "Load weight" },
      ].map((item) => {
        return (
          <Button key={item.id} variant={item.id === parseInt(chartViewType) ? "primary" : "default"} onClick={() => dispatch(setChartViewType(item.id))} disabled={isDisable} eventkey={item.id} className="btn-type">
            {item.name}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};

export default SubViewToggle;
